"use strict";
/* globals module */
/**
 * @module calendarBatchRoute
 * @description BaasicCalendarBatchRoute Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use BaasicCalendarBatch Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var common_1 = require("../../common");
var contracts_1 = require("../../core/contracts");
var CalendarBatchRoute = /** @class */ (function (_super) {
    tslib_1.__extends(CalendarBatchRoute, _super);
    function CalendarBatchRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.createRoute = 'calendars/batch';
        _this.updateRoute = 'calendars/batch';
        _this.deleteRoute = 'calendars/batch';
        return _this;
    }
    /**
     * Parses create route. This URI template does not expose any additional options.
     * @method
     * @example calendarBatchRoute.create();
     */
    CalendarBatchRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses update route. This URI template does not expose any additional options.
     * @method
     * @example calendarBatchRoute.update();
     */
    CalendarBatchRoute.prototype.update = function () {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, {});
    };
    /**
     * Parses delte route. This URI template does not expose any additional options.
     * @method
     * @example calendarBatchRoute.delete();
     */
    CalendarBatchRoute.prototype.delete = function () {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, {});
    };
    var _a;
    CalendarBatchRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], CalendarBatchRoute);
    return CalendarBatchRoute;
}(common_1.BaseRoute));
exports.CalendarBatchRoute = CalendarBatchRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 
